var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"LOGISTICS_NUMBER"},[_c('Input',{staticClass:"LOGISTICS_NUMBER__input",attrs:{"autocomplete":'new-password',"disabled":_vm.isDisabled,"placeholder":_vm.t('请在输入后按回车')},on:{"on-blur":_vm.inputblur,"on-enter":_vm.inputenter},model:{value:(_vm.valuedata),callback:function ($$v) {_vm.valuedata=$$v},expression:"valuedata"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }